// extracted by mini-css-extract-plugin
export default {"exercise":"Exercise_exercise__bUzHC"};